webpackJsonp([0],{

/***/ "+749":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap",on:{"mousemove":_vm.dragMove,"mouseup":_vm.dragUp}},[_c('div',{staticClass:"utils_left"},[_c('div',{staticClass:"spr_sheets"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showInfo),expression:"showInfo"}],staticClass:"utils_info"},[_vm._m(0),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_vm._l((_vm.sprSheetsData),function(item,index){return _c('div',{staticClass:"spr_views",attrs:{"id":'views' + index}},[_c('div',{staticClass:"canvas_parent"},[_c('canvas',{attrs:{"width":item.width,"height":item.height,"id":'canvas'+index,"data-index":index}}),_vm._v(" "),_c('div',{staticClass:"canvas_move"},[_c('span',{staticClass:"close fa fa-close",attrs:{"data-index":index},on:{"click":_vm.delView}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(index != 0),expression:"index != 0"}],staticClass:"go_prev fa fa-arrow-up",attrs:{"data-index":index},on:{"click":_vm.onArrowUp}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(index != (_vm.sprSheetsData.length-1)),expression:"index != (sprSheetsData.length-1)"}],staticClass:"go_next fa fa-arrow-down",attrs:{"data-index":index},on:{"click":_vm.onArrowDown}})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(index != 0),expression:"index != 0"}],staticClass:"drag_top",staticStyle:{"top":"90%"},style:({ top: item.dragTop}),attrs:{"id":'dragTp'+ index,"data-index":index},on:{"mousedown":_vm.dragStart}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(index != 0),expression:"index != 0"}],staticClass:"drag_bot",staticStyle:{"top":"100%"},attrs:{"id":'dragBt'+ index,"data-index":index},on:{"mousedown":_vm.dragStart}})])}),_vm._v(" "),_c('button',{on:{"click":_vm.addPic}},[_vm._m(2)])],2)]),_vm._v(" "),_c('div',{staticClass:"utils_right"},[_c('div',{staticClass:"right_box"},[_c('div',{staticClass:"canvas_thumb"},[_c('canvas',{directives:[{name:"show",rawName:"v-show",value:(_vm.showThumb),expression:"showThumb"}],attrs:{"id":"showThumbnails"}})]),_vm._v(" "),_c('button',{attrs:{"disabled":_vm.btnShow},on:{"click":_vm.createViewShow}},[_vm._m(3)]),_vm._v(" "),_c('button',{staticStyle:{"margin-top":"10px"},attrs:{"disabled":_vm.btnSave},on:{"click":_vm.saveViewShow}},[_vm._m(4)]),_vm._v(" "),_c('a',{attrs:{"id":"dl","download":"截图.jpg"}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isMobile),expression:"isMobile"}],staticClass:"isMobile"},[_vm._v("仅支持PC端浏览器哦！")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top"},[_c('p',[_c('strong',[_vm._v("您可以很方便的使用它拼接电影字幕")])]),_vm._v(" "),_c('p',[_vm._v("推荐使用 Chrome、FireFox、IE11、Edge ")]),_vm._v(" "),_c('p',[_vm._v("可以给我提Bug： "),_c('a',{attrs:{"href":"mailto:474014965@qq.com"}},[_vm._v("Email")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dl',[_c('dt',[_c('strong',[_vm._v("使用方法：")])]),_vm._v(" "),_c('dd',[_c('p',[_vm._v("1、点击【添加屏幕截图】按钮选择图片，可多选")]),_vm._v(" "),_c('p',[_vm._v("2、移动手柄调整好要截取的位置")]),_vm._v(" "),_c('p',[_vm._v("3、点击右侧【生成预览图】按钮")]),_vm._v(" "),_c('p',[_vm._v("4、点击右侧【保存预览图】按钮")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"fa fa-plus-square"},[_c('strong',[_vm._v("添加屏幕截图")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"fa fa-play-circle"},[_c('strong',[_vm._v("生成预览图")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"fa fa-download"},[_c('strong',[_vm._v("保存预览图")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5r33":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/alipay.29e2fef.jpg";

/***/ }),

/***/ "6FOO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"header"},[_c('PayMoney'),_vm._v(" "),_c('h1',[_vm._v("电影字幕拼接工具")])],1),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9Lcx":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wx.19840e7.jpg";

/***/ }),

/***/ "CphK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DICR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pay_vue__ = __webpack_require__("mTUd");
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'app',
  components: {
    PayMoney: __WEBPACK_IMPORTED_MODULE_0__components_pay_vue__["a" /* default */]
  },
  data: function data() {
    return {};
  },

  methods: {}
});

/***/ }),

/***/ "GJUF":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/* FileSaver.js
 * A saveAs() FileSaver implementation.
 * 1.3.2
 * 2016-06-16 18:25:19
 *
 * By Eli Grey, http://eligrey.com
 * License: MIT
 *   See https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
 */

/*global self */
/*jslint bitwise: true, indent: 4, laxbreak: true, laxcomma: true, smarttabs: true, plusplus: true */

/*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */

var saveAs = saveAs || (function(view) {
  "use strict";
  // IE <10 is explicitly unsupported
  if (typeof view === "undefined" || typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) {
    return;
  }
  var
    doc = view.document
    // only get URL when necessary in case Blob.js hasn't overridden it yet
    , get_URL = function() {
      return view.URL || view.webkitURL || view;
    }
    , save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a")
    , can_use_save_link = "download" in save_link
    , click = function(node) {
      var event = new MouseEvent("click");
      node.dispatchEvent(event);
    }
    , is_safari = /constructor/i.test(view.HTMLElement) || view.safari
    , is_chrome_ios =/CriOS\/[\d]+/.test(navigator.userAgent)
    , throw_outside = function(ex) {
      (view.setImmediate || view.setTimeout)(function() {
        throw ex;
      }, 0);
    }
    , force_saveable_type = "application/octet-stream"
    // the Blob API is fundamentally broken as there is no "downloadfinished" event to subscribe to
    , arbitrary_revoke_timeout = 1000 * 40 // in ms
    , revoke = function(file) {
      var revoker = function() {
        if (typeof file === "string") { // file is an object URL
          get_URL().revokeObjectURL(file);
        } else { // file is a File
          file.remove();
        }
      };
      setTimeout(revoker, arbitrary_revoke_timeout);
    }
    , dispatch = function(filesaver, event_types, event) {
      event_types = [].concat(event_types);
      var i = event_types.length;
      while (i--) {
        var listener = filesaver["on" + event_types[i]];
        if (typeof listener === "function") {
          try {
            listener.call(filesaver, event || filesaver);
          } catch (ex) {
            throw_outside(ex);
          }
        }
      }
    }
    , auto_bom = function(blob) {
      // prepend BOM for UTF-8 XML and text/* types (including HTML)
      // note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
      if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
        return new Blob([String.fromCharCode(0xFEFF), blob], {type: blob.type});
      }
      return blob;
    }
    , FileSaver = function(blob, name, no_auto_bom) {
      if (!no_auto_bom) {
        blob = auto_bom(blob);
      }
      // First try a.download, then web filesystem, then object URLs
      var
        filesaver = this
        , type = blob.type
        , force = type === force_saveable_type
        , object_url
        , dispatch_all = function() {
          dispatch(filesaver, "writestart progress write writeend".split(" "));
        }
        // on any filesys errors revert to saving with object URLs
        , fs_error = function() {
          if ((is_chrome_ios || (force && is_safari)) && view.FileReader) {
            // Safari doesn't allow downloading of blob urls
            var reader = new FileReader();
            reader.onloadend = function() {
              var url = is_chrome_ios ? reader.result : reader.result.replace(/^data:[^;]*;/, 'data:attachment/file;');
              var popup = view.open(url, '_blank');
              if(!popup) view.location.href = url;
              url=undefined; // release reference before dispatching
              filesaver.readyState = filesaver.DONE;
              dispatch_all();
            };
            reader.readAsDataURL(blob);
            filesaver.readyState = filesaver.INIT;
            return;
          }
          // don't create more object URLs than needed
          if (!object_url) {
            object_url = get_URL().createObjectURL(blob);
          }
          if (force) {
            view.location.href = object_url;
          } else {
            var opened = view.open(object_url, "_blank");
            if (!opened) {
              // Apple does not allow window.open, see https://developer.apple.com/library/safari/documentation/Tools/Conceptual/SafariExtensionGuide/WorkingwithWindowsandTabs/WorkingwithWindowsandTabs.html
              view.location.href = object_url;
            }
          }
          filesaver.readyState = filesaver.DONE;
          dispatch_all();
          revoke(object_url);
        }
      ;
      filesaver.readyState = filesaver.INIT;

      if (can_use_save_link) {
        object_url = get_URL().createObjectURL(blob);
        setTimeout(function() {
          save_link.href = object_url;
          save_link.download = name;
          click(save_link);
          dispatch_all();
          revoke(object_url);
          filesaver.readyState = filesaver.DONE;
        });
        return;
      }

      fs_error();
    }
    , FS_proto = FileSaver.prototype
    , saveAs = function(blob, name, no_auto_bom) {
      return new FileSaver(blob, name || blob.name || "download", no_auto_bom);
    }
  ;
  // IE 10+ (native saveAs)
  if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) {
    return function(blob, name, no_auto_bom) {
      name = name || blob.name || "download";

      if (!no_auto_bom) {
        blob = auto_bom(blob);
      }
      return navigator.msSaveOrOpenBlob(blob, name);
    };
  }

  FS_proto.abort = function(){};
  FS_proto.readyState = FS_proto.INIT = 0;
  FS_proto.WRITING = 1;
  FS_proto.DONE = 2;

  FS_proto.error =
    FS_proto.onwritestart =
      FS_proto.onprogress =
        FS_proto.onwrite =
          FS_proto.onabort =
            FS_proto.onerror =
              FS_proto.onwriteend =
                null;

  return saveAs;
}(
  typeof self !== "undefined" && self
  || typeof window !== "undefined" && window
  || this.content
));
// `self` is undefined in Firefox for Android content script context
// while `this` is nsIContentFrameMessageManager
// with an attribute `content` that corresponds to the window

if (typeof module !== "undefined" && module.exports) {
  module.exports.saveAs = saveAs;
} else if (("function" !== "undefined" && __webpack_require__("g5To") !== null) && (__webpack_require__("eOn/") !== null)) {
  !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
    return saveAs;
  }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_3_0_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("DICR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_3_0_vue_loader_lib_template_compiler_index_id_data_v_b405dc7c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_3_0_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("6FOO");
function injectStyle (ssrContext) {
  __webpack_require__("brbX")
}
var normalizeComponent = __webpack_require__("46Yf")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_3_0_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_3_0_vue_loader_lib_template_compiler_index_id_data_v_b405dc7c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_3_0_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("MVSX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("MVSX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("zO6J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__("lO7g");




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home__["a" /* default */]
  }]
}));

/***/ }),

/***/ "brbX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eG5A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lO7g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_3_0_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("xM0o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_3_0_vue_loader_lib_template_compiler_index_id_data_v_71b4e9ce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_3_0_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("+749");
function injectStyle (ssrContext) {
  __webpack_require__("CphK")
}
var normalizeComponent = __webpack_require__("46Yf")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-71b4e9ce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_3_0_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_3_0_vue_loader_lib_template_compiler_index_id_data_v_71b4e9ce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_3_0_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mTUd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_3_0_vue_loader_lib_selector_type_script_index_0_pay_vue__ = __webpack_require__("tUku");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_3_0_vue_loader_lib_template_compiler_index_id_data_v_120adffe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_3_0_vue_loader_lib_selector_type_template_index_0_pay_vue__ = __webpack_require__("sMJR");
function injectStyle (ssrContext) {
  __webpack_require__("eG5A")
}
var normalizeComponent = __webpack_require__("46Yf")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-120adffe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_3_0_vue_loader_lib_selector_type_script_index_0_pay_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_3_0_vue_loader_lib_template_compiler_index_id_data_v_120adffe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_3_0_vue_loader_lib_selector_type_template_index_0_pay_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sMJR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"pay fa fa-dollar",on:{"click":_vm.onClickShowPay}},[_c('span',[_vm._v("觉得好用？支持作者")])]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPay),expression:"showPay"}],staticClass:"thanks",on:{"click":_vm.onClickHidePay}},[_c('div',{staticClass:"thk_cont"},[_c('p',[_c('img',{attrs:{"src":__webpack_require__("5r33"),"alt":""}}),_vm._v(" "),_c('strong',[_vm._v("支付宝")])]),_vm._v(" "),_c('p',[_c('img',{attrs:{"src":__webpack_require__("9Lcx"),"alt":""}}),_vm._v(" "),_c('strong',[_vm._v("微信")])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tUku":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'pay',
  data: function data() {
    return {
      showPay: false
    };
  },

  methods: {
    onClickShowPay: function onClickShowPay() {
      this.showPay = true;
    },
    onClickHidePay: function onClickHidePay() {
      this.showPay = false;
    }
  }
});

/***/ }),

/***/ "xM0o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_FileSaver__ = __webpack_require__("GJUF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_FileSaver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__static_FileSaver__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      msg: '',
      sprSheetsData: [], //主体数据
      btnSelect: true,
      btnShow: true,
      btnSave: true,
      showInfo: true,
      isMobile: false,
      dragBarObj: null,
      showThumb: false,
      curViewIndex: 0,
      status: 0, //1 添加  2 删除  3 移动位置
      dragObjY: 0,
      curCanvas: null,
      dragOldXY: {
        y: 0
      },
      selectView: null,
      inputEl: null
    };
  },
  created: function created() {
    this.inputEl = function () {
      var input = document.createElement("INPUT");
      input.type = 'file';
      input.accept = 'image/png,image/jpeg,image/gif';
      input.multiple = true;
      return input;
    }();
    this.inputEl.addEventListener('change', this._changeHandler, false);

    var ua = navigator.userAgent;
    var ipad = ua.match(/(iPad).*OS\s([\d_]+)/),
        isIphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/),
        isAndroid = ua.match(/(Android)\s+([\d.]+)/),
        isMobile = isIphone || isAndroid;
    if (isMobile) {
      this.isMobile = true;
    }
  },
  mounted: function mounted() {},
  updated: function updated() {
    var s = this;
    //console.dir(this.sprSheetsData);
    var sprData = this.sprSheetsData;
    var views = document.querySelectorAll(".spr_views");

    if (!s.status) return;
    for (var i = 0; i < sprData.length; i++) {
      var iView = sprData[i];
      var canvas = views[i].querySelector("canvas");
      var ctx = canvas.getContext("2d");
      var sprSheetBox = document.querySelector('.spr_sheets');
      iView.scale = sprSheetBox.offsetWidth / iView.img.width;
      ctx.clearRect(0, 0, iView.width, iView.height);
      ctx.drawImage(iView.img, 0, 0);
      ctx.fillStyle = 'rgba(0,0,0,0.5)';
      /**
       * 判断不是第一个，才重置透明层和拖动杆
       */
      if (i != 0) {
        /**
         * 判断，没有拖动过，那要计算下画出的透明层高度
         * 反之，直接读取存储需要裁剪的高度和Y轴位置
         */
        if (!iView.dragEd) {
          iView.viewRect = {
            y: iView.height * .9,
            height: iView.height * .1
          };
          ctx.fillRect(0, 0, iView.width, iView.viewRect.y);
          document.getElementById("dragBt" + i).style.top = iView.dragBot;
        } else {
          ctx.fillRect(0, 0, iView.width, iView.viewRect.y);
          ctx.fillRect(0, iView.viewRect.y + iView.viewRect.height, iView.width, iView.height);

          document.getElementById("dragTp" + i).style.top = iView.dragTop;
          document.getElementById("dragBt" + i).style.top = iView.dragBot;
        }
      }
      ctx.save();
    }
    //console.log("update!");
    s.status = 0;
  },

  methods: {
    /**
     * 删除当前层
     * @param ev { MouseEvent }
     */
    delView: function delView(ev) {
      var s = this;
      var delIndex = ev.target.dataset.index;
      s.status = 1;
      this.sprSheetsData.splice(delIndex, 1);
      if (this.sprSheetsData.length === 0) {
        s.showInfo = true;
        s.showThumb = false;
        s.btnShow = true;
        s.btnSave = true;
      }
    },
    /**
     * 向上移动事件
     * @param ev { MouseEvent }
     */
    onArrowUp: function onArrowUp(ev) {
      var s = this;
      var index = Number(ev.target.dataset.index);
      var thisData = s.sprSheetsData[index];
      var prevData = s.sprSheetsData[index - 1];

      this.$set(s.sprSheetsData, index - 1, thisData);
      this.$set(s.sprSheetsData, index, prevData);
      s.status = 3;
    },
    /**
     * 向下移动事件
     * @param ev { MouseEvent }
     */
    onArrowDown: function onArrowDown(ev) {
      var s = this;
      var index = Number(ev.target.dataset.index);
      var thisData = s.sprSheetsData[index];
      var nextData = s.sprSheetsData[index + 1];
      this.$set(s.sprSheetsData, index, nextData);
      this.$set(s.sprSheetsData, index + 1, thisData);
      s.status = 3;
    },
    /**
     * 点击添加图片事件
     * @param event { MouseEvent }
     */
    addPic: function addPic(event) {
      var s = this;
      s.inputEl.click();
    },
    /**
     * 生成缩略图预览
     */
    createViewShow: function createViewShow() {
      var s = this;
      if (s.btnShow) return;
      var thumHeight = 0;
      var thumCanvasWidth = 500;
      var thumCanvas = document.getElementById("showThumbnails");
      s.showThumb = true;
      var ctx = thumCanvas.getContext('2d');
      var rectAfterHeight = 0;
      var drawY = 0;
      ctx.clearRect(0, 0, 10000, 10000);
      for (var i = 0; i < s.sprSheetsData.length; i++) {
        var item = s.sprSheetsData[i];
        /**
         * 换算下放到400px宽度的canvas下，被裁切的区域的高度
         */
        if (i == 0) {
          rectAfterHeight = thumCanvasWidth / item.width * item.height;
          item.thumb = {
            y: 0,
            height: rectAfterHeight
          };
        } else {
          rectAfterHeight = thumCanvasWidth / item.width * item.viewRect.height;
          item.thumb = {
            y: s.sprSheetsData[i - 1].thumb.height + s.sprSheetsData[i - 1].thumb.y,
            height: rectAfterHeight
          };
        }

        thumHeight += rectAfterHeight;
        s.btnSave = false;
      }
      thumCanvas.setAttribute('width', thumCanvasWidth);
      thumCanvas.setAttribute('height', thumHeight);
      /**
       * 画出所有裁切位置
       */
      for (var i = 0; i < s.sprSheetsData.length; i++) {
        var item = s.sprSheetsData[i];
        ctx.drawImage(item.img, 0, i == 0 ? 0 : item.viewRect.y, item.width, i == 0 ? item.height : item.viewRect.height, 0, item.thumb.y, thumCanvasWidth, item.thumb.height);
      }
    },
    /**
     * 保存缩略图
     */
    saveViewShow: function saveViewShow(ev) {
      var s = this;
      if (s.btnSave) return;
      function isIE() {
        //ie?
        if (!!window.ActiveXObject || "ActiveXObject" in window) return true;else return false;
      }
      var canvas = document.getElementById("showThumbnails");
      var ctx = canvas.getContext("2d");
      var btnDl = document.getElementById("dl");
      if (canvas.msToBlob) {
        var blob = canvas.msToBlob();
        window.navigator.msSaveBlob(blob, '截图.png');
      } else {
        var dt = canvas.toDataURL('image/jpeg', '1.0');
        dt = dt.replace(/^data:image\/[^;]*/, 'data:application/octet-stream');
        dt = dt.replace(/^data:application\/octet-stream/, 'data:application/octet-stream;headers=Content-Disposition%3A%20attachment%3B%20filename=截图.jpg');
        btnDl.href = dt;
        btnDl.click();
      }
    },
    /**
     * 拖动点上事件
     * @param ev
     */
    dragStart: function dragStart(ev) {
      var s = this;
      var obj = ev.target;
      var index = Number(obj.getAttribute("data-index"));
      if (index != 0) {
        if (ev.target.className === 'drag_top') {
          //console.log("第一个");
        } else {
            //console.log("第2个");
          }
        s.dragBarObj = obj;

        s.selectView = document.getElementById("views" + index);
        s.dragObjY = Number(s.dragBarObj.style.top.replace('%', '')) / 100 * s.selectView.offsetHeight;
        s.dragOldXY.y = ev.y;
        s.curCanvas = document.getElementById("canvas" + index);
        s.curViewIndex = index;
        s.sprSheetsData[index].dragEd = true;
        //console.log(s.curViewIndex);
      } else {}
    },
    /**
     * 拖动中事件
     * @param ev
     */
    dragMove: function dragMove(ev) {
      var s = this;
      if (s.dragBarObj) {
        var viewOffsetTop = s.selectView.offsetHeight;
        var y = ev.y - s.dragOldXY.y;

        s.dragObjY += y;
        if (s.dragObjY > viewOffsetTop) {
          s.dragObjY = viewOffsetTop;
        } else if (s.dragObjY < 0) {
          s.dragObjY = 0;
        }
        s.dragBarObj.style.top = s.dragObjY / viewOffsetTop * 100 + "%";
        s.drawCanvas();
        s.dragOldXY.y = ev.y;
      }
    },
    /**
     * 拖动结束事件
     * @param ev
     */
    dragUp: function dragUp() {
      var s = this;
      s.dragBarObj = null;
      s.selectView = null;
    },
    /**
     * 拖动过程中，重画透明层方法
     */
    drawCanvas: function drawCanvas() {
      var s = this;
      //第一个操纵杆
      var thisSheet = s.sprSheetsData[s.curViewIndex];
      var dgTop = document.getElementById("dragTp" + s.curViewIndex);
      var dgBot = document.getElementById("dragBt" + s.curViewIndex);

      //重新后去下view和canvas，因为在添加第二章图片的时候，第一个canvas宽度会有变化
      s.selectView = document.getElementById("views" + s.curViewIndex);
      s.curCanvas = document.getElementById("canvas" + s.curViewIndex);

      var dy1 = Number(dgTop.style.top.replace('%', '')) / 100 * s.selectView.offsetHeight;
      var dy2 = Number(dgBot.style.top.replace('%', '')) / 100 * s.selectView.offsetHeight;

      var ctx = s.curCanvas.getContext('2d');
      thisSheet.scale = s.curCanvas.offsetWidth / thisSheet.width;
      //第一块半透明的y
      var alpha1Y = Math.min(dy1, dy2) / thisSheet.scale;
      var alpha2Y = Math.max(dy1, dy2) / thisSheet.scale;
      ctx.clearRect(0, 0, s.curCanvas.width, s.curCanvas.height);
      //画底图
      ctx.drawImage(thisSheet.img, 0, 0);
      //给canvas画半透明层
      ctx.fillStyle = 'rgba(0,0,0,0.5)';
      ctx.fillRect(0, 0, thisSheet.width, alpha1Y + 1);
      //存储下2个操作杆的位置
      thisSheet.dragTop = dgTop.style.top;
      thisSheet.dragBot = dgBot.style.top;
      //设置裁切的区域
      thisSheet.viewRect = {
        y: alpha1Y,
        height: alpha2Y - alpha1Y
      };

      ctx.fillRect(0, alpha2Y + 2, thisSheet.width, s.selectView.offsetHeight / thisSheet.scale);
      ctx.fill();
    },
    /**
     * input change 事件
     * @param event
     * @private
     */
    _changeHandler: function _changeHandler(event) {
      var s = this;
      // event.path[0].files;
      var files = event.path ? event.path[0].files : event.target.files;
      window.URL = window.URL || window.webkitURL;

      for (var i = 0; i < files.length; i++) {
        var src = window.URL.createObjectURL(files[i]);
        //console.log(src);
        s.createView(src, i, files.length);
      }
      s.inputEl.value = "";
      s.btnShow = false;
      s.showInfo = false;
    },
    /**
     * 画选择的图片
     * @param src
     */
    createView: function createView(src, curIndex, maxLen) {
      var s = this;
      var img = new Image();
      //var pageLeft = document.querySelector(".utils_left");
      img.onload = function () {
        s.sprSheetsData.push({
          width: img.width,
          height: img.height,
          scale: 1,
          viewRect: {
            y: 0,
            height: 0
          },
          img: img,
          dragTop: "90%",
          dragBot: "100%",
          dragEd: false, // 是否已经产生了拖动
          src: src
        });
        s.status = 1;
      };
      img.src = src;
    }
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.acca8e8fbfaa76eace4a.js